var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHistory({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-inline--fa fa-fw",
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.10651 13.9186C6.05013 15.2174 7.43071 16.132 8.99462 16.4945C10.5585 16.857 12.2007 16.643 13.6195 15.8918C15.0383 15.1406 16.1383 13.9026 16.7176 12.4054C17.2968 10.9082 17.3163 9.25222 16.7725 7.74176C16.2287 6.2313 15.1581 4.96779 13.7574 4.18337C12.3568 3.39896 10.7201 3.14631 9.14805 3.47186C7.57603 3.79741 6.17428 4.67928 5.20033 5.95546C4.22638 7.23164 3.74565 8.81641 3.84645 10.4186M3.84645 10.4186L2.59645 9.16861M3.84645 10.4186L5.09645 9.16861",
    stroke: "currentColor",
    strokeOpacity: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 6.66667V10L13 12.5",
    stroke: "currentColor",
    strokeOpacity: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default "data:image/svg+xml;base64,PHN2ZyBjbGFzc05hbWU9InN2Zy1pbmxpbmUtLWZhIGZhLWZ3IiB2aWV3Qm94PSIwIDAgMjEgMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik01LjEwNjUxIDEzLjkxODZDNi4wNTAxMyAxNS4yMTc0IDcuNDMwNzEgMTYuMTMyIDguOTk0NjIgMTYuNDk0NUMxMC41NTg1IDE2Ljg1NyAxMi4yMDA3IDE2LjY0MyAxMy42MTk1IDE1Ljg5MThDMTUuMDM4MyAxNS4xNDA2IDE2LjEzODMgMTMuOTAyNiAxNi43MTc2IDEyLjQwNTRDMTcuMjk2OCAxMC45MDgyIDE3LjMxNjMgOS4yNTIyMiAxNi43NzI1IDcuNzQxNzZDMTYuMjI4NyA2LjIzMTMgMTUuMTU4MSA0Ljk2Nzc5IDEzLjc1NzQgNC4xODMzN0MxMi4zNTY4IDMuMzk4OTYgMTAuNzIwMSAzLjE0NjMxIDkuMTQ4MDUgMy40NzE4NkM3LjU3NjAzIDMuNzk3NDEgNi4xNzQyOCA0LjY3OTI4IDUuMjAwMzMgNS45NTU0NkM0LjIyNjM4IDcuMjMxNjQgMy43NDU2NSA4LjgxNjQxIDMuODQ2NDUgMTAuNDE4Nk0zLjg0NjQ1IDEwLjQxODZMMi41OTY0NSA5LjE2ODYxTTMuODQ2NDUgMTAuNDE4Nkw1LjA5NjQ1IDkuMTY4NjEiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utb3BhY2l0eT0iMC43IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEwLjUgNi42NjY2N1YxMEwxMyAxMi41IiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLW9wYWNpdHk9IjAuNyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };